/** 用户协议 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="需求方管理"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        title="轻节点任务开关"
        class="bonus-code-layout"
      >
        <el-alert
          title="先开启开关后，再指定不同运营商限额，点击确定生效，不限额输入9999999999."
          type="error"
        >
        </el-alert>
        <!-- 增加任务 -->
        <div class="button" @click="showAddTask = true">增加任务</div>
        <el-table
          v-if="config && config.length"
          :data="config"
          style="width: 100%"
        >
          <el-table-column
            prop="type"
            label="任务类型"
          >
          </el-table-column>
          <el-table-column label="前端开关">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.open"
                @change="changeOpen(scope.row, 'open')"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="是否限额">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.openLimit"
                @change="changeOpen(scope.row, 'openLimit', scope.$index)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="运营商限额">
            <template slot-scope="scope">
              <div v-if="scope.row.openLimit">
                <div class="display-flex-center margin-bottom-20">
                  <span style="min-width:50px">移动</span>
                  <!-- 移动限额数量 -->
                  <el-input
                    v-if="scope.row['移动']"
                    @change="changeOpen(scope.row, '移动', scope.$index)"
                    v-model="scope.row['移动'].count"
                    placeholder="硬盘GB"
                  ></el-input>
                  <!-- 是否限制城市 -->
                  <el-switch
                    class="margin-20"
                    v-if="scope.row['移动']"
                    v-model="scope.row['移动'].cityLimit"
                    @change="changeOpen(scope.row, 'cityLimit', scope.$index)"
                  >
                  </el-switch>
                  <!-- 城市限制列表 -->
                  <el-select 
                    v-if="scope.row['移动'] && scope.row['移动'].count && scope.row['移动'].cityLimit"
                    v-model="scope.row['移动'].citys" multiple placeholder="请选择" @change="changeOpen(scope.row, 'cityList', scope.$index)">
                    <el-option
                      v-for="item in cityLists"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <!-- 联通设置 -->
                <div class="display-flex-center margin-bottom-20">
                  <span style="min-width:50px">联通</span>
                  <!-- 联通限额 -->
                  <el-input
                    v-if="scope.row['联通']"
                    @change="changeOpen(scope.row, '联通', scope.$index)"
                    v-model="scope.row['联通'].count"
                    placeholder="硬盘GB"
                  ></el-input>
                  <!-- 是否限制城市 -->
                  <el-switch
                    class="margin-20"
                    v-if="scope.row['联通']"
                    v-model="scope.row['联通'].cityLimit"
                    @change="changeOpen(scope.row, 'cityLimit', scope.$index)"
                  >
                  </el-switch>
                  <!-- 城市限制列表 -->
                  <el-select 
                    v-if="scope.row['联通'] && scope.row['联通'].count && scope.row['联通'].cityLimit"
                    v-model="scope.row['联通'].citys" multiple placeholder="请选择" @change="changeOpen(scope.row, 'cityList', scope.$index)">
                    <el-option
                      v-for="item in cityLists"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <!-- 电信 -->
                <div class="display-flex-center ">
                  <span style="min-width:50px">电信</span>
                  <el-input
                    v-if="scope.row['电信']"
                    @change="changeOpen(scope.row, '电信', scope.$index)"
                    v-model="scope.row['电信'].count"
                    placeholder="硬盘GB"
                  ></el-input>
                  <!-- 是否限制城市 -->
                  <el-switch
                    class="margin-20"
                    v-if="scope.row['电信']"
                    v-model="scope.row['电信'].cityLimit"
                    @change="changeOpen(scope.row, 'cityLimit', scope.$index)"
                  >
                  </el-switch>
                  <!-- 城市限制列表 -->
                  <el-select 
                    v-if="scope.row['电信'] && scope.row['电信'].count && scope.row['电信'].cityLimit"
                    v-model="scope.row['电信'].city" multiple placeholder="请选择" @change="changeOpen(scope.row, 'cityList', scope.$index)">
                    <el-option
                      v-for="item in cityLists"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 是否限制城市 -->
          <!-- <el-table-column label="是否限制城市">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.cityLimit"
                @change="changeOpen(scope.row, 'cityLimit', scope.$index)"
              >
              </el-switch>
            </template>
          </el-table-column> -->
          <!-- 城市限制列表 -->
          <!-- <el-table-column label="城市限制列表">
            <template slot-scope="scope">
              
            </template>
          </el-table-column> -->
        </el-table>
      </BasiceLayout>
      <el-dialog
        title="增加任务"
        :visible.sync="showAddTask"
        width="480px"
        center
      >
        <div class="addnote-dialog-wrap">
          <input
            placeholder="输入任务名"
            type="text"
            class="basic-input input addnote-input"
            v-model="taskName"
          >
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <div
            class="sure-unbind button"
            @click="showAddTask = false"
          >{{ $t('cancel') }}</div>
          <div
            class="sure-unbind button"
            type="primary"
            @click="addTask"
          >{{ $t('confirm') }}</div>
        </span>
      </el-dialog>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Layout from "@/components/CRM/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { cityLists } from "@/utils/cityLists";

export default {
  name: "home",
  data() {
    return {
      config: "",
      showAddTask: false,
      taskName: "",
      cityLists,
    };
  },
  computed: mapState({}),
  components: {
    Layout,
    BasiceLayout,
  },
  methods: {
    ...mapActions(["getStatus", "setStatus", "setTask"]),
    changeOpen(item, type, index) {
      let { config } = this;

      // 如果第一次开通限额，初始化限额字段
      console.log(item);
      if (type === "openLimit") {
        if (!item['移动'] || !item['电信'] || !item['联通']) {
          Object.assign(item, {
              联通: {
              count: 0
            }, 电信: {
              count: 0
            }, 移动: {
              count: 0
            }
          })
          this.config[index] = item;
        }
      }


      this.setStatus({
        type: "newScheduleConfig",
        value: JSON.stringify(this.config),
        redisBD: "session",
      });

      this.getStatus({ type: "newScheduleConfig", redisBD: "session" });
    },
    addTask() {
      let {taskName} = this;
      this.setTask({
        taskName
      }).then(res => {
        let config = JSON.parse(res.message);
        this.config = config;
        this.showAddTask = false
      });
    }
  },
  created() {

    this.getStatus({ type: "newScheduleConfig", redisBD: "session" }).then(
      (res) => {
        // let res = { "message": "[{\"open\":true,\"openTime\":true,\"start\":\"\",\"end\":\"\",\"type\":\"A\"},{\"open\":true,\"openTime\":\"false\",\"type\":\"B\"},{\"open\":true,\"openTime\":\"\",\"type\":\"C\"},{\"open\":true,\"openTime\":\"\",\"type\":\"D\"},{\"open\":true,\"openTime\":\"false\",\"type\":\"E\"},{\"open\":true,\"openLimit\":true,\"openLimitCounts\":{\"联通\":0,\"电信\":0,\"移动\":0},\"type\":\"F\"}]" };
        let config = JSON.parse(res.message);
        console.log(config)
        this.config = config;
      }
    );
  },
};
</script>

<style  lang="stylus">
.node-dial-content {
  width: 80%;
}

.crm-node-content {
  padding-top: 80px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  text-align: left;
}

.label-button {
  max-width: 100%;
}
</style>
